import 'typescript/lib/lib.dom.d.ts'; // adds support for web globals as we need them here

import store from '../../stores/store';
import utils from '../../utils/utils';
import api from './../axios';
import moment from 'moment';
import { getStarContainer } from '../../utils/timeService';

export const uploadPracticeSessions = async (emptyPayload: unknown) => {
  const userId = store.getState().signedInUser?.user?._id;
  const uniqueKey = `practiceSessions${userId}`;
  const practiceSessions = store.getState().practiceSessionsWithKey[uniqueKey];
  const sessions = emptyPayload
    ? { practiceSessions: [] }
    : { practiceSessions: practiceSessions || [] };

  try {
    const res = await api.post(`/api/practicesessions`, sessions);
    const storedSessions: Record<string, { duration: number }> = {};
    if (!emptyPayload) {
      res.data.practiceDurations.forEach(function (duration: any) {
        duration._id.month = duration._id.month - 1;
        storedSessions[moment(duration._id).format('YYYY-MM-DD')] = {
          duration: duration.duration,
        };
      });
      store
        .getActions()
        .storeServerPracticeSessions({ uniqueKey, storedSessions });
      getStarContainer();
    }
    store.getActions().setPracticeSessionsWithKey('reset');
    if (emptyPayload === null) {
      utils.getTheLatestPracticeSessionTime(res.data?.practiceDurations);
    }
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const downloadPracticeSessions = async (token: string) => {
  try {
    const { data } = await api.get(
      'api/patients/practicesessions/export/bundle',
      {
        headers: {
          Authorization: `JWT ${token}`,
          Accept: 'application/json',
          'Content-type': 'application/json',
        },
      },
    );
    const dataBlob = new Blob([JSON.stringify(data, null, 2)], {
      type: 'application/json',
    });
    const urlBlob = URL.createObjectURL(dataBlob);
    const aTagForDownload = window.document.createElement('a');
    // automated click for the a tag to download the link
    aTagForDownload.href = urlBlob;
    aTagForDownload.download = 'Übungsdauer.json';
    aTagForDownload.click();
    aTagForDownload.remove();
  } catch (error) {
    return Promise.reject(error);
  }
};
